import React from "react";

/**
 * Official Lu.ft logo (lilac wordmark + royal blue dot on black background).
 * Used consistently across the site as a refined brand badge.
 */
export const Logo = ({ className = "", size = "default" }) => {
  const dimensions =
    size === "footer" ? "h-16 sm:h-20" : "h-12 sm:h-14";

  return (
    <span
      className={`inline-flex items-center select-none ${className}`}
      data-testid="luft-logo"
    >
      <img
        src="/media/logo-luft.png"
        alt="Lu.ft Pilates Studio"
        className={`${dimensions} w-auto`}
        loading="eager"
      />
    </span>
  );
};

export default Logo;
